import(/* webpackMode: "eager", webpackExports: ["BrandDiscountPageTemplate"] */ "/app/src/modules/brand/pages/BrandDiscountPageTemplate.tsx");
